/* OROS Design — Theme JS */

(function () {
  'use strict';

  // ── Nav mobile toggle ──────────────────────────────────────
  var toggle = document.getElementById('nav-toggle');
  var menu   = document.getElementById('nav-menu');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var isOpen = !menu.hidden;
      menu.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    // Close on anchor click
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ── Product configurator ───────────────────────────────────
  var swatches  = document.querySelectorAll('.config-swatch');
  var configImg = document.getElementById('config-img');
  var colorLbl  = document.getElementById('config-color-label');
  var variantId = document.getElementById('variant-id');

  if (swatches.length && configImg) {
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {

        // Update active state
        swatches.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        // Swap image with fade
        var newSrc = btn.dataset.img;
        var newAlt = btn.dataset.alt;
        if (newSrc) {
          configImg.style.opacity = '0';
          setTimeout(function () {
            configImg.src = newSrc;
            if (newAlt) configImg.alt = newAlt;
            configImg.style.opacity = '1';
          }, 150);
        }

        // Update label
        if (colorLbl && btn.dataset.label) {
          colorLbl.textContent = btn.dataset.label;
        }

        // Update Shopify variant ID
        if (variantId && btn.dataset.variantId) {
          variantId.value = btn.dataset.variantId;
        }
      });
    });
  }

  // ── Cart form feedback ─────────────────────────────────────
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      var addBtn = productForm.querySelector('[name="add"]');
      if (addBtn) {
        addBtn.disabled  = true;
        addBtn.textContent = 'Ajout en cours…';
      }
      // Shopify handles the actual cart submission;
      // re-enable on error (Shopify fires 'cart:error' or page reloads on success)
      setTimeout(function () {
        if (addBtn) {
          addBtn.disabled    = false;
          addBtn.textContent = 'Ajouter au panier';
        }
      }, 3000);
    });
  }

  // ── Cart count badge ────────────────────────────────────────
  var cartBadges = document.querySelectorAll('#cart-count, .cart-count-badge');
  if (cartBadges.length) {
    fetch('/cart.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;
        cartBadges.forEach(function (badge) {
          if (count > 0) {
            badge.textContent = count;
            badge.classList.remove('hidden');
          } else {
            badge.classList.add('hidden');
          }
        });
      })
      .catch(function () {});
  }

  // ── Cart page controls ──────────────────────────────────────
  function updateCart(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    });
  }

  document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.dataset.line, 10);
      var quantityLabel = btn.parentElement && btn.parentElement.querySelector('span');
      var quantity = quantityLabel ? parseInt(quantityLabel.textContent, 10) : 0;
      if (!line || !quantity) return;

      if (btn.dataset.action === 'minus' && quantity > 1) {
        updateCart(line, quantity - 1).catch(function () {});
      } else if (btn.dataset.action === 'plus') {
        updateCart(line, quantity + 1).catch(function () {});
      }
    });
  });

  document.querySelectorAll('.cart-remove-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.dataset.line, 10);
      if (line) updateCart(line, 0).catch(function () {});
    });
  });

  var dateInput = document.getElementById('delivery-date');
  var checkoutBtn = document.getElementById('checkout-btn');
  if (dateInput && checkoutBtn) {
    var min = new Date();
    var added = 0;
    while (added < 7) {
      min.setDate(min.getDate() + 1);
      if (min.getDay() !== 0 && min.getDay() !== 6) added++;
    }
    dateInput.min = min.toISOString().split('T')[0];

    checkoutBtn.addEventListener('click', function (event) {
      if (!dateInput.value) {
        event.preventDefault();
        dateInput.focus();
        dateInput.reportValidity();
        return;
      }

      event.preventDefault();
      checkoutBtn.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Date de livraison': dateInput.value } })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart attributes update failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          checkoutBtn.disabled = false;
        });
    });
  }

  // ── Cookie consent ──────────────────────────────────────────
  var banner = document.getElementById('cookie-banner');
  var accept = document.getElementById('cookie-accept');
  var refuse = document.getElementById('cookie-refuse');
  var cookieName = 'oros_cookie_consent';

  function getStoredConsent() {
    try {
      if (localStorage.getItem(cookieName) || localStorage.getItem('cookie_consent')) return true;
    } catch (e) {}

    return document.cookie.split(';').some(function (cookie) {
      return cookie.trim().indexOf(cookieName + '=') === 0;
    });
  }

  function storeConsent(value) {
    try {
      localStorage.setItem(cookieName, value);
      localStorage.setItem('cookie_consent', value);
    } catch (e) {}

    document.cookie = cookieName + '=' + encodeURIComponent(value) + '; Max-Age=31536000; Path=/; SameSite=Lax';
    if (banner) banner.classList.add('hidden');
  }

  if (banner && !getStoredConsent()) {
    banner.classList.remove('hidden');
  }
  if (accept) accept.addEventListener('click', function () { storeConsent('accepted'); });
  if (refuse) refuse.addEventListener('click', function () { storeConsent('refused'); });

})();
